import React from "react";
import { BaseLayout } from "@components/components";

export const ContactsBase = () => {
    return <BaseLayout full />;
};
